import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { marker as _ } from '@biesbjerg/ngx-translate-extract-marker';
import { FieldType } from '@ngx-formly/core';
import { ClipboardService } from 'ngx-clipboard';
import { ButtonModule } from 'primeng/button';
import { InputGroup } from 'primeng/inputgroup';
import { InputText } from 'primeng/inputtext';
import { I18nService } from '../../../@core/services/i18n/i18n.service';
import { NotificationService } from '../../../@core/services/notification/notification.service';

@Component({
  selector: 'app-website-input',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './formly-website-input.component.html',
  imports: [
    CommonModule,
    InputGroup,
    ButtonModule,
    InputText,
    ReactiveFormsModule
  ]
})
export class FormlyWebsiteInput extends FieldType {

  dataTestId = computed(() => {
    return this.field?.props?.attributes?.['data-testid'] ?? "formly-website";
  });

  constructor(private i18nService: I18nService,
    private clipboardService: ClipboardService, private notificationService: NotificationService,
    private router: Router) {
    super();
  }

  copyToClipboard(text: string) {
    this.clipboardService.copyFromContent(text);
    this.notificationService.success(_("common.copied-to-clipboard"), { entity: "company" });
  }

  openExternalLink(url: string) {
    if (url.startsWith("https://") || url.startsWith("http://")) {
      this.router.navigate([]).then(res => {
        window.open(url, "_blank")
      })
    } else {
      url = "https://" + url
      this.router.navigate([]).then(res => {
        window.open(url, "_blank")
      })
    }
  }

  btnClick(e) {
    this.openExternalLink(this.formControl.value)
  }
}
